/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { DtoAssignUsers } from '../../models/dto-assign-users';

export interface RegistryControllerAssignRegistry$Params {
      body: DtoAssignUsers
}

export function registryControllerAssignRegistry(http: HttpClient, rootUrl: string, params: RegistryControllerAssignRegistry$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse>> {
  const rb = new RequestBuilder(rootUrl, registryControllerAssignRegistry.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse>;
    })
  );
}

registryControllerAssignRegistry.PATH = '/registry/registry';
